import React from "react";
import { useSelector } from "react-redux";
import { Dimmer, Image, Loader, Segment } from "semantic-ui-react";

const LoaderComponent = ({
  children,
  commonLoading,
  className,
  imageRows = 1,
}) => {
  const loadingStatus = useSelector((state) => state.isLoaderStatus);

  return loadingStatus || commonLoading ? (
    <Segment className={`${className} !border-0`}>
      <Dimmer active>
        {" "}
        <Loader inline="centered"></Loader>
      </Dimmer>
      {Array.from({ length: imageRows }, (_, i) => i).map((row) => {
        return (
          <Image
            className="!mb-[10px]"
            src="https://react.semantic-ui.com/images/wireframe/short-paragraph.png"
          />
        );
      })}
    </Segment>
  ) : (
    <>{children}</>
  );
};

export default LoaderComponent;
